import { render, staticRenderFns } from "./commentsBox.vue?vue&type=template&id=b1d75d40&scoped=true"
import script from "./commentsBox.vue?vue&type=script&lang=js"
export * from "./commentsBox.vue?vue&type=script&lang=js"
import style0 from "./commentsBox.vue?vue&type=style&index=0&id=b1d75d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d75d40",
  null
  
)

export default component.exports